import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import SelectField from './SelectField';
import CheckboxField from './CheckboxField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';

let RollingArrangementForm = ({
  handleSubmit,
  error,
  btnText,
  saveStatus,
  paymentMethods = [],
}) => {
  const sortedPaymentMethods = [].concat(paymentMethods).sort((a, b) => {
    if (a.is_default) {
      return -1;
    } else if (b.is_default) {
      return 1;
    }

    return 0;
  });

  const cardSelectOptions = sortedPaymentMethods.map(
    ({
      id,
      card_brand,
      card_last_four,
      expiration_month,
      expiration_year,
      echeck_type,
      account_number,
    }) =>
      echeck_type
        ? [id, account_number]
        : [
            id,
            `${card_brand} **** ${card_last_four} ${expiration_month}/${expiration_year}`,
          ],
  );

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={InputField}
        type="number"
        name="arrangement_day"
        label="Arrangement Day"
      />
      <Field
        component={SelectField}
        name="card_id"
        label="Card"
        options={cardSelectOptions}
        empty="Select card"
      />
      <Field
        component={InputField}
        type="number"
        name="cycles_count"
        label="Cycles Count"
      />
      <Field component={CheckboxField} name="enabled" label="Enabled" />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        {btnText}
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  );
};

const validate = (values) => {
  const requiredFields = ['arrangement_day', 'cycles_count', 'card_id'];
  let errors = {};

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

RollingArrangementForm = reduxForm({
  form: 'rollingArrangement',
  validate,
})(RollingArrangementForm);

export default RollingArrangementForm;
